import React, { useState } from 'react';
import { LayoutDashboard, Lock, Sun } from 'lucide-react';
import { ChangePasswordSettings } from './components/ChangePasswordSettings';
import { DashboardSettings } from './components/DashboardSettings';
import { AppearanceSettings } from './components/AppearanceSettings';

export const SettingsPage = () => {
  const [activeTab, setActiveTab] = useState('change-password');

  const tabs = [
    { id: 'change-password', label: 'Change Password', icon: Lock, component: ChangePasswordSettings },
    { id: 'dashboard', label: 'Dashboard', icon: LayoutDashboard, component: DashboardSettings },
    { id: 'appearance', label: 'Appearance', icon: Sun, component: AppearanceSettings },
  ];

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-neutral-900 text-gray-900 dark:text-neutral-100 pb-12">
      {/* Header Section */}
      <div className="bg-white dark:bg-neutral-800 border-b border-gray-200 dark:border-neutral-700 sticky top-0 z-10">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="py-6">
                <h1 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-white">Settings</h1>
                <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
                    Manage your account settings and preferences.
                </p>
            </div>
            
            {/* Tabs */}
            <div className="flex space-x-8 overflow-x-auto no-scrollbar">
                {tabs.map((tab) => {
                    const Icon = tab.icon;
                    const isActive = activeTab === tab.id;
                    return (
                        <button
                            key={tab.id}
                            onClick={() => setActiveTab(tab.id)}
                            className={`
                                group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm transition-all duration-200 whitespace-nowrap
                                ${isActive 
                                    ? 'border-blue-600 text-blue-600 dark:text-blue-400' 
                                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-200 dark:hover:border-neutral-600'
                                }
                            `}
                        >
                            <Icon className={`
                                -ml-0.5 mr-2 h-4 w-4 transition-colors duration-200
                                ${isActive ? 'text-blue-600 dark:text-blue-400' : 'text-gray-400 group-hover:text-gray-500 dark:text-gray-500 dark:group-hover:text-gray-300'}
                            `} />
                            {tab.label}
                        </button>
                    );
                })}
            </div>
        </div>
      </div>

      {/* Content Section */}
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {tabs.map((tab) => (
             activeTab === tab.id && <tab.component key={tab.id} />
        ))}
      </div>
    </div>
  );
};